import React from 'react'
import { CloseIcon } from '~/assets/svg'

class Embed extends React.Component {
  render() {
    var str = `<iframe allowfullscreen="true" src="${window.location.origin}/embed/player?filmId=${this.props.videoId}"/>`
    return (
      <div className="embed-prompt">
        <div className="embed-overlay">
          <div onClick={this.props.toggleEmbed}> <CloseIcon /></div>
          <textarea className="copy-text" rows="4" cols="50" defaultValue={str}/>
          <button className="copy-button" onClick={this.copy}>Copy</button>
        </div>
      </div>
    )
  }
  copy() {
    var copyText = document.getElementsByClassName("copy-text")[0];
    copyText.select();
    document.execCommand("Copy");
    document.querySelector('.copy-button').innerHTML = 'Copied'
  }
}

export default Embed